import {
    ADD_CREDIT_LIMIT_MODEL_SUCCESS,
} from '../Create/action';
const initialState = {
    addCreditLimitModelResponse: [],
}

const creditLimitModelAddReducer = (state=initialState, action) => {
    switch(action.type) {
        case ADD_CREDIT_LIMIT_MODEL_SUCCESS:
            return  state = {
                ...state,
                addCreditLimitModelResponse: action.data
            }   
        default: return state
    }
}
export default creditLimitModelAddReducer;
